import React from 'react'
import {
  ChevronIcon,
  HelpIcon,
  UndoIcon,
} from '../icons'
import { HOST } from '../../utils/env'
import styles from './styles'

const handleBackClick = () => window.history.back()

const PinOptions = () => (
  <ul>
    <li>
      <a className="pin-option" href={`https://player.${HOST}/settings/#forgotten-pin`}>
        <HelpIcon title="" />
        <span>Forgot your PIN</span>
      </a>
    </li>
    <li>
      <a className="pin-option" href={`https://player.${HOST}/settings/#change-pin`}>
        <UndoIcon title="" />
        <span>Change PIN</span>
      </a>
    </li>
    <li>
      <button
        className="pin-option"
        type="button"
        onClick={handleBackClick}
      >
        <ChevronIcon
          direction="left"
          width={15}
          height={25}
        />
        <span>Cancel and go back</span>
      </button>
    </li>
    <style jsx>{styles}</style>
  </ul>
)

export default PinOptions
